// 登录页埋点事件名
export const click_direct_login = 'Click Direct Login';

// 用户设置页埋点事件名
export const view_user_settings_page = 'View User Settings Page';

// 用户访问无权限页面
export const view_no_permission_page = 'View No Permission Page';

// 技能提升的资料 - 页面进入
export const entry_skillfile_page = 'Entry SkillFile Page';
// 技能提升的资料 - 下载资料
export const download_skillfile = 'Download SkillFile';
// 技能提升的资料 - 跳转其他产品
export const skillfile_jump_to_page = 'SkillFile Jump To Page';

export const go_to_other_product_from_limit = 'Go To Other Product From Limit'
export const open_continue_use_account_modal = 'Open Continue Use Account Modal'
export const confirm_continue_use_account_modal = 'Confirm Continue Use Account Modal'
export const change_other_account = 'Change Other Account'
export const refresh_data_upper_limit = 'Refresh Data Upper Limit'
export const view_upper_limit_page = 'View Upper Limit Page'
